<template>

  <div class="row">
	 
    <div class="col-md-12">
      <h4 class="title">Adhoc Task Log</h4>
      <p class="category">
      Excludes Regulatory Tasks.
      </p>
    </div>
    
    <div style="text-align:right;">
		  <fg-input >
                  <el-select class="select-primary"
                             size="large"
                             @change="onViewRangeTypeChange($event)"
                             placeholder="Select Type"
                             v-model="viewRange"

                             >
                    <el-option v-for="option in selects.viewRange"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>

    </div>
    
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Extended</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select style="display:none;"
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search Company"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div id="cs_companies_pg" class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%" @row-click="viewPerson">
           
			   <el-table-column label="Company"  property="task.entity_name" width="200"> </el-table-column>
			   <el-table-column sortable label="Updated" property="task.updated_at_str" width="120"> </el-table-column>
			   <el-table-column sortable label="Task ID" property="task.id" width="120"> </el-table-column>
            
               <el-table-column label="Type" width="150">
            		<template slot-scope="scope" >
           				 <span v-if="scope.row.type=='change_officer'">Change: Officer</span>
           				 <span v-if="scope.row.type=='change_member'">Change: Member</span>
           				 <span v-if="scope.row.type=='change_shareholder'">Change: Shares</span>
           				 <span v-if="scope.row.type=='change_coy_info'">Change: Company Details</span>
						<span v-if="scope.row.type=='change_share_cert'">Change: Share Certificate</span>
						<span v-if="scope.row.type=='reso_items'">Custom Resolution Item</span>
						<span v-if="scope.row.type=='share_cert'">Share Certificate</span>
						<span v-if="scope.row.type=='general'">General</span>
          			</template>   
               </el-table-column>
               
               <el-table-column label="Description" width="" >
                		<template slot-scope="scope" >
                		
                		<span v-if="scope.row.type=='reso_items'">           				 
           				 	 {{scope.row.data.text}}
           				 </span>
           				 
           				 <span v-if="scope.row.type=='share_cert'">           				 
           				 	Share Certificate #{{scope.row.data.cert_number}}
           				 </span>
           				 
           				  <span v-if="scope.row.type=='general'">           				 
           				 	{{scope.row.data.name}}
           				 </span>
           				 
                		
           				 <span v-if="scope.row.type=='change_officer'">
           				 	 <span v-if="scope.row.data.officer_status==1">Appointment Of Officer:</span>
           				 	 <span v-if="scope.row.data.officer_status==2">Resignation Of Officer:</span>
           				 
           				 	 {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}})
           				 </span>
           				 
           				 
           				  <span v-if="scope.row.type=='change_member'">
           				 	 <span v-if="scope.row.data.member_status==1">Appointment Of Member:</span>
           				 	 <span v-if="scope.row.data.member__status==2">Resignation Of Member:</span>
           				 
           				 	 {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}})
           				 </span>
           				 
           				 
           				 <span v-if="scope.row.type=='change_share_cert'">
           				 	 <span v-if="scope.row.data.type==1">Issue</span>
           				 	 <span v-if="scope.row.data.type==2">Cancel</span>
           				  Share Certificate #{{scope.row.data.share_cert.cert_number}}
           				 	
           				 </span>
           				 
           				 
           				  <span v-if="scope.row.type=='change_shareholder'">
           				 	 
           				 	  {{scope.row.data.num_shares}} 
           				 	    <span v-if="scope.row.data.share_type==1">Ordinary</span>
								  <span v-if="scope.row.data.share_type==2">Preference</span>
								  <span v-for="st in scope.row.data.share_types">
									  <span v-if="scope.row.data.share_type==st.id">{{st.name}}</span>
								  </span>
							  
           				 	   Shares
           				 	  ({{scope.row.data.paid_up_capital}} {{scope.row.data.currency}})
           				     <span v-if="scope.row.data.transaction_type==3">
								From 	
								<span v-if="scope.row.data.company_info2">
								
									{{scope.row.data.company_info2.company_name}}  ({{scope.row.data.company_info2.company_reg_num}} )
								
								</span>
								
								<span v-else> {{scope.row.data.person2.first_name}}  {{scope.row.data.person2.last_name}} ( {{scope.row.data.person2.gov_id}})</span>
           				 	 </span>
							To:  
							
								<span v-if="scope.row.data.company_info">
								
									{{scope.row.data.company_info.company_name}}  ({{scope.row.data.company_info.company_reg_num}} )
								
								</span>
           				 	<span v-else>  {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}}) </span>
           				 </span>
           				
           				
           				<!-- change: coy info--> 
           				 <span v-if="scope.row.type=='change_coy_info'">
           				 	 <span v-if="scope.row.data.ch_type=='ch_coy_fye'">
           				 	 	Financial Year-end Date Change To:
           				 	 	{{scope.row.data.date_field_1_str}} 
           				 	 </span>
           				 	 
           				 	 
           				 	  <span v-if="scope.row.data.ch_type=='ch_coy_activity'">
								Primary Activity Change To: ({{scope.row.data.str_field_1}}) {{scope.row.data.str_field_2}}
								<br/> Secondary Activity Change To: ({{scope.row.data.str_field_4}}) {{scope.row.data.str_field_5}}
           				 	 </span>
           				 	 
           				 	 
           				 	 <span v-if="scope.row.data.ch_type=='ch_coy_name'">
           				 	 	Company Name Change To:
           				 	 	{{scope.row.data.str_field_1}} 
           				 	 </span>
           				 	 
           				 	 <span v-if="scope.row.data.ch_type=='ch_address'">
           				 	 	Company Address Change To:
           				 	 	{{scope.row.data.str_field_1}} 
           				 	 </span>
           				 	 
           				 	 
           				 	  <span v-if="scope.row.data.ch_type=='ch_strike_off'">
           				 	 	Striking-off Of Company
           				 	 </span>
           				 	 
           				 </span>
      
           				 
           				<!-- end: change: coy info--> 

          			</template>                
                </el-table-column>
                
                 <el-table-column sortable label="Created" property="task.created_by" width="150"> </el-table-column>
                
                 <el-table-column label="Status" width="90" >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.data.status==1"><i style="color:orange;font-size:24px;" class="nc-icon nc-sound-wave"></i></span>
						<span v-if="scope.row.data.status==4"><i style="color:green;font-size:24px;" class="nc-icon nc-check-2"></i></span>
						<span v-if="scope.row.data.status==5"><i style="color:red;font-size:24px;" class="nc-icon nc-simple-remove"></i></span>
						
						
							<span v-if="scope.row.type=='reso_items'">-</span>
          			</template>                
                </el-table-column>
                
                
                    <el-table-column label="View" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="goToTask(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
               
               
     
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    
    
     <div style="text-align:right;width:100%">
 	 <p-button type="info" @click="goToCreatePerson()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Add New Person
      </p-button>
  </div>
  
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
     
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
      	viewRange:'td',
      	tableTd:'',
      	tableYd:'',
      	table7d:'',
      	table30d:'',
      	tableTm:'',
      	tableLm:'',
      	tableL3m:'',
      	selects: {
          viewRange: [
            {value: "td", label: 'Today'},
            {value: "yd", label: 'Yesterday'},
            {value: "7d", label: 'Last 7 Days'},
            {value: "30d", label: 'Last 30 Days'},
            {value: "tm", label: 'This Month'},
            {value: "lm", label: 'Last Month'},
            {value: "l3m", label: 'Last 3 Months'},
		   ],
		},
        pagination: {
          perPage: 25,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['task_entity_name'],
        tableColumns: [
          
          {
            prop: 'last_name',
            label: 'Last Name',
            minWidth: 80
          },
 
          {
            prop: 'address_1',
            label: 'Address',
            minWidth: 250
          },
          {
            prop: 'contact_num',
            label: 'Contact Number',
            minWidth: 90
          },

          
 


        ],
        tableData: []
      }
    },
    mounted() {
     	this.loadTaskTable(this.viewRange);
    },
    methods: {
      loadTaskTable(vr){
      	  let loadNew = false;
      	  if(vr == "td"){
      	  	if(this.tableTd){
      	  		 this.tableData = this.tableTd;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  
      	  }
      	  else if(vr == "yd"){
      	  	if(this.tableYd){
      	  		
      	  		 this.tableData = this.tableYd;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	  else if(vr == "7d"){
      	  	if(this.table7d){
      	  		
      	  		 this.tableData = this.table7d;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	  else if(vr == "30d"){
      	  	if(this.table30d){
      	  		
      	  		 this.tableData = this.table30d;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	  else if(vr == "tm"){
      	  	if(this.tableTm){
      	  		
      	  		 this.tableData = this.tableTm;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	  else if(vr == "lm"){
      	  	if(this.tableLm){
      	  		
      	  		 this.tableData = this.tableLm;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	   else if(vr == "l3m"){
      	  	if(this.tableL3m){
      	  		
      	  		 this.tableData = this.tableL3m;
      	  	}
      	  	else{
      	  		loadNew = true;
      	  	}
      	  }
      	  
      	  
      	 if(loadNew){
      	  swal.showLoading();
		  let uri = this.$base_url+'/api/v1/tasks/get/all/'+vr;
		  ApiService.get(uri).then(response => {
			let tasks_cr = response.data.tasks_cr;
			
			
			 if(vr == "td"){
				this.tableTd = tasks_cr;
			 }
			 else if(vr == "yd"){
			 	this.tableYd = tasks_cr;
			 }
			 else if(vr == "7d"){
			 	this.table7d = tasks_cr;
			 }
			 else if(vr == "30d"){
			 	this.table30d = tasks_cr;
			 }
			 else if(vr == "tm"){
			 	this.tableTm = tasks_cr;
			 }
			 else if(vr == "lm"){
			 	this.tableLm = tasks_cr;
			 }
			 else if(vr == "l3m"){
			 	this.tableL3m = tasks_cr;
			 }
		
			 this.tableData = tasks_cr;
			 swal.close();
		  })
      
      	}
      
      },
      onViewRangeTypeChange(){
    		this.loadTaskTable(this.viewRange);
      },
      goToTask(row){
      	this.$router.push( '/edit-task/'+row.task.id+'/entity/'+row.task.entity_id)
      },
      goToEditPerson(row){
      	 this.$router.push( '/create-person/'+row.id)
      },
      goToCreatePerson(){
      	 this.$router.push( '/create-person/0')
      },
      handleTask (index, row) {
        let entity_id = this.tableData[index].id;
        
        this.$router.push( '/create-task/'+entity_id)
      },
      viewPerson(row) {

      },
      handleEdit (index, row) {
      
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      }
    }
  }
</script>
<style lang="scss">

  
</style>
